export function getWacHostApplications(_a) {
    var isCommercialUser = _a.isCommercialUser, isConsumerUser = _a.isConsumerUser, visioWacHostEnabled = _a.visioWacHostEnabled, wacHostApps = _a.wacHostApps, wacHostAppsConsumer = _a.wacHostAppsConsumer;
    if (isCommercialUser) {
        var wacHostAppList = wacHostApps === '' ? [] : wacHostApps.split(',');
        if (visioWacHostEnabled) {
            wacHostAppList.push('visio');
        }
        return wacHostAppList;
    }
    else if (isConsumerUser) {
        return wacHostAppsConsumer === '' ? [] : wacHostAppsConsumer.split(',');
    }
    return [];
}
//# sourceMappingURL=getWacHostApplications.js.map